import { ProjectRPCSession } from '#/services/session';
import { FreshJobGetRequest } from '#/services/jobs/requests';
import { queryProjectClient } from '#/clients';
import store from '#/store';

// eslint-disable-next-line import/prefer-default-export
export class JobGetSession extends ProjectRPCSession {
  constructor(jobIds) {
    super();
    if (!jobIds) {
      throw new Error('cannot create a job get session without a job id');
    }
    this.jobIds = jobIds;
    this.request = FreshJobGetRequest(this.jobIds);
    this.job = undefined;

    this.loading = false; // a request is open over the wire
  }

  async load() {
    if (this.loading) {
      return false;
    }
    this.loading = true;
    console.info('loading jobs', this.jobIds);

    const headers = await this.headers();
    return new Promise((resolve, reject) => {
      queryProjectClient.getJobs(this.request, headers, (err, response) => {
        if (err != null) {
          console.log('received err from getJobs ', err);
          this.error = err;
          return reject(err);
        }

        const list = response.getJobsList();
        if (list[0] !== undefined) {
          const jobProto = list[0];
          this.job = jobProto.toObject();
          store.commit('jobs/setJobDetails', jobProto);
          console.log('loaded job: ', this.job);
        }

        return resolve(response);
        // TODO: commit mutations on store to set jobs
        // TODO: remove list from dispatch in jobs. - relegate to this session
        // return resolve(response.toObject());
      });
    }).finally(() => {
      this.loading = false;
    });
  }

  // catch(error) {
  //   console.log('caught error loading job page:', error);
  //   this.error = error;
  //   return Promise.reject(error);
  // }
}
